import 'core-js/stable';
import 'regenerator-runtime/runtime';

import * as Sentry from '@sentry/react';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-175458421-1');

Sentry.init({
  dsn: 'https://e275ba8883ef446689a88479e6739500@o410231.ingest.sentry.io/5283958',
});
